<div class="grafiek-totaal-container">
  <p class="title">Percentage gebruik van geactiveerde licenties</p>
  <div class="grafiek-container" *ngIf="(notLoading | async) && dataLoaded">
    <google-chart [data]="weekendData" (chartReady)="onWeekendReady()"></google-chart>
    <google-chart class="chart" [data]="chartData" (chartReady)="onReady()"></google-chart>
  </div>
</div>
